<template>
  <div class="not-found-page d-flex flex-column align-items-center justify-content-center">
    <div>404</div>
    <div>Page Not Found</div>
  </div>
</template>

<script>
export default {
  name: "NotFound",
  data() {
    return {};
  },
};
</script>

<style lang="scss">
.not-found-page {
  width: 100%;
  height: 100%;

  >div {
    &:nth-child(1) {
      font-weight: 600;
      font-size: 128px;
    }
    &:nth-child(2) {
      font-weight: 500;
      font-size: 24px;
    }
  }

  * {
    text-align: center;
  }
}
</style>